module.exports = "pegasus_template/assets/theme2/medium/4.jpg";